export const ACTION_LOAD_PRICING = "supportui/PricingPage/ACTION_LOAD_PRICING";
export const ACTION_PRICING_LOADED =
  "supportui/PricingPage/ACTION_PRICING_LOADED";
export const ACTION_UPLOAD_PRICING =
  "supportui/PricingPage/ACTION_UPLOAD_PRICING";
export const ACTION_UPLOAD_PRICING_SUCCEEDED =
  "supportui/PricingPage/ACTION_UPLOAD_PRICING_SUCCEEDED";
export const ACTION_UPLOAD_PRICING_FAILED =
  "supportui/PricingPage/ACTION_UPLOAD_PRICING_FAILED";
export const ACTION_SAVE_PRICING = "supportui/PricingPage/ACTION_SAVE_PRICING";
export const ACTION_PRICING_SAVED =
  "supportui/PricingPage/ACTION_PRICING_SAVED";
export const ACTION_COMPLETE_PRICING_UPLOAD =
  "supportui/PricingPage/ACTION_COMPLETE_PRICING_UPLOAD";
export const ACTION_DOWNLOAD_PRICING =
  "supportui/PricingPage/ACTION_DOWNLOAD_PRICING";
export const ACTION_DOWNLOAD_PRICING_STARTED =
  "supportui/PricingPage/ACTION_DOWNLOAD_PRICING_STARTED";
